const StaticPage = () => import(/* webpackChunkName: "static-page" */ '@/views/staticPages/StaticPage')

export default [{
  path: 'employers/post-job-ad',
  name: 'static-for-employers',
  component: StaticPage,
  props: {
    pathToLoad: '/api/helper/landing/employer'
  }
}, {
  path: 'jobseeker',
  name: 'static-for-jobseeker',
  component: StaticPage,
  props: {
    pathToLoad: '/api/helper/landing/jobseeker'
  }
}]
